import { render } from "./CustomerLoginView.vue?vue&type=template&id=35af0130&scoped=true&ts=true"
import script from "./CustomerLoginView.vue?vue&type=script&lang=ts"
export * from "./CustomerLoginView.vue?vue&type=script&lang=ts"

import "./CustomerLoginView.vue?vue&type=style&index=0&id=35af0130&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35af0130"]])

export default __exports__